import { MqttClient } from '@src/mqtt_browser';
import { mmHost } from '@src/Main/main';

export function getPendantAvailability (onSuccess, timeout = 0) {
  // NOTE: One time use MQTT client
  // NOTE: We will not use the mqtt_instance.getClient as we need to be able to catch missing MQTT broker

  let timeoutTimer;
  const wifiAvailable = 'devices/pendant/available';
  const wifiAvailableRegex = new RegExp(wifiAvailable);

  const onMessage = (topic, message) => {
    clearTimeout(timeoutTimer);
    mqttClientInstance.unsubscribe(wifiAvailable, wifiAvailableRegex, onMessage);
    mqttClientInstance.mqttClient.end();
    onSuccess(JSON.parse(message));
  };

  // open a websocket on MQTT
  const mqttClientInstance = new MqttClient(mmHost, 9001, function () {
    // Sometimes we can't end the mqtt in the timeout, we will catch it here
    if (timeoutTimer === null) { mqttClientInstance.mqttClient.end(); return; }

    // Pendant availability
    mqttClientInstance.subscribe(wifiAvailable, wifiAvailableRegex, onMessage);
  });

  if (timeout) {
    timeoutTimer = setTimeout(() => {
      try { mqttClientInstance.mqttClient.end(); }
      catch (e) { console.error('fail to unsubscribe'); }
      onSuccess(false);
      timeoutTimer = null;
    }, timeout);
  }
}
